export const GetOverviewSelector = ({
  yusaOvernightCampOverviewData: { getYusaOvernightCampOverview }
}) => getYusaOvernightCampOverview;

export const GetBrachYearWiseReportSelector = ({
  yusaOvernightCampOverviewData: { getBrachYearWiseReport }
}) => getBrachYearWiseReport;
